(() => {
  $(document).on(
    "click",
    ".product-form-sentrySelector .item:not(.disabled)",
    function () {
      // update active styles
      $(this).siblings(".item").removeClass("active");
      $(this).addClass("active");

      // update selected option
      $(this)
        .closest(".option-wrapper")
        .find("label .sel")
        .text($(this).attr("data-sel-text") ?? $(this).attr("data-option"));

      if ($(this).attr("data-product-id")) {
        $(
          ".product-form-sentrySelector .option-wrapper:not([data-option='Model'])",
        ).addClass("hide");
      }
      $(
        `.product-form-sentrySelector .option-wrapper[data-product-id="${$(this).attr("data-product-id")}"]`,
      ).removeClass("hide");

      // update and trigger dropdown
      updateDropdown();
    },
  );

  $("[name='variant_id']").on("change", function () {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", $(this).val());
    window.history.replaceState(null, "", url.toString());

    const option = $(this).find(`option[value='${$(this).val()}']`);
    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr("data-handle", option.attr("data-handle"));
    $("#currentSelection").attr(
      "data-stockNum",
      option.attr("data-stockIndicatorNum"),
    );
    $(".subtitle[data-variant_title]").text(option.attr("data-option") || "");

    updateLinks();
    updatePrice();
    updateInstallment();
    updateVoucher();

    toggleATCbuttons();
    updateImage();
    updateLeadTime();
  });

  function updateDropdown() {
    let options = [];
    $(
      ".option-wrapper:not(.hide):not([data-option='Model']) .item.active",
    ).each(function () {
      options.push($(this).attr("data-option"));
    });
    const select = $("[name='variant_id']");
    select.val(select.find(`[data-option='${options.join(" / ")}']`).val());
    select.trigger("change");
  }

  function toggleATCbuttons() {
    const atcButton = $("#AddToCart-button");
    const checkoutBtn = $("#initateCheckout");
    const soldOutBtn = $("#sold-out-btn");

    const selValue = $("[name='variant_id']").val();
    const selOption = $(`[name='variant_id'] option[value='${selValue}']`);

    if (selOption.attr("data-available") == "true") {
      atcButton.show();
      checkoutBtn.show();
      soldOutBtn.addClass("hide");
    } else {
      atcButton.hide();
      checkoutBtn.hide();
      soldOutBtn.removeClass("hide");
    }
  }

  function updateImage() {
    const value = $("[name='variant_id']").val();
    const option = $(`[name='variant_id'] option[value='${value}']`);
    const handle = option.attr("data-handle");

    // a temporary fix for Sentry 2026 not showing the correct thumbs
    // second line was suggested by Claude, I've commented it out since it might not have any use for now
    //let key = handle.replace(/-bundle/g, "").replace(/-privacy/g, "");
    // if (/privacy/.test(handle)) key = key.replace(/^sentry-/, "sentra-");

    console.log('sentry handle'+handle);
    $(".product-single__thumbnails-items").removeClass("active");
    $(".product-single__thumbnails-items." + handle).addClass("active");

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + handle + " a").addClass(
      "active-thumb",
    );

    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  function updateLeadTime() {
    const option = $(
      `[name='variant_id'] option[value="${$("[name='variant_id']").val()}"]`,
    );

    if (option.attr("data-restock")) {
      $(".custom-attributes.product-restocks p").html(
        option.attr("data-restock"),
      );
    }
  }

  const moveOptionsToMainSelect = () => {
    // move the options to main select if not exist
    const select = $("#ProductSelect-product-template");
    if (!select.length) return;

    $("[name='variant_id'] option").each((_, x) => {
      if (!select.find(`option[value="${$(x).attr("value")}"]`).length) {
        select.append($(x).clone());
      }
    });
  };

  toggleATCbuttons();
  updateImage();
  updateLeadTime();
  moveOptionsToMainSelect();
})();
